import { Injectable } from '@angular/core';
import { Observable, fromEvent, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { AppHttpHeadersService } from '../headers/app-http-headers.service';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoService {
  constructor(
    private http: HttpClient,
    private appHttpHeadersService: AppHttpHeadersService
  ) {}

  getProfilePhoto(email, useTimestamp: boolean = false): Observable<any> {
    return this.http.get(
      environment.gateway_api + '/photo/' + email + '/profile' + (useTimestamp === true ? `?timestamp=${new Date().getTime()}` : ''),
      { headers: this.appHttpHeadersService.getHeaders(), responseType: 'blob' }
    );
  }

  getPhotoByEmail(email: string, useTimestamp: boolean = false): Observable<any> {
    return this.getProfilePhoto(email, useTimestamp).pipe(
      switchMap(data => {
        if (data !== null) {
          // convert image file to base64 string
          const reader = new FileReader();
          const imageLoader = fromEvent(reader, 'load').pipe(map(() => reader.result));
          reader.readAsDataURL(data);
          return imageLoader;
        } else {
          return undefined;
        }
      }),
      catchError(error => {
        return of(undefined);
      })
    );
  }
}
